<!-- <app-advance-calendar (apply)="onApply($event)"></app-advance-calendar> -->
<router-outlet></router-outlet>
<p-toast position="bottom-left">
  <!-- <ng-template let-message pTemplate="message">
    <i
      class="ui-toast-icon pi"
      [ngClass]="{
        'pi-exclamation-triangle': message.severity === 'error',
        'pi-check-circle': message.severity === 'success',
        'pi-exclamation-circle': message.severity === 'warn',
        'pi-info-circle': message.severity === 'info'
      }"
    ></i>
    <h3>{{ message.summary }}</h3>
    <p>{{ message.detail }}</p>
  </ng-template> -->
</p-toast>
<!-- <p-toast key="sticky" styleClass="sticky--notification" position="bottom-right" [baseZIndex]="5000">
  <ng-template let-message pTemplate="message">
    <i
      class="p-toast-icon pi"
      [ngClass]="{
        'pi-exclamation-triangle': message.severity === 'error',
        'pi-check-circle': message.severity === 'success',
        'pi-exclamation-circle': message.severity === 'warn',
        'pi-info-circle': message.severity === 'info'
      }"
    ></i>
    <h3>{{ message.summary }}</h3>
    <p>{{ message.detail }}</p>
    <button type="button" (click)="onReload()" class="btn btn--secondary btn--small">{{ 'Reload' | translate }}</button>
  </ng-template>
</p-toast> -->
